import { Routes } from '@angular/router';
import { InstitutionIdFromQueryParamsGuard } from '@core/guards/institution-id-from-query-params.guard';
import { KeycloakAuthGuard } from '@core/guards/keycloakAuth.guard';
import { QuestionnaireComponent } from './ui/questionnaire.component';
import { BlankoDokumenteComponent } from './ui/questions/blanko-dokumente/blanko-dokumente.component';
import { DepotbankWahlComponent } from './ui/questions/depotbank-wahl/depotbank-wahl.component';
import { DokumenteComponent } from './ui/questions/dokumente/dokumente.component';
import { EinsichtComponent } from './ui/questions/einsicht/einsicht.component';
import { IdentifizierungComponent } from './ui/questions/identifizierung/identifizierung.component';
import { OverviewComponent } from './ui/questions/overview/overview.component';
import { ZusammenfassungComponent } from './ui/questions/zusammenfassung/zusammenfassung.component';

export const QUESTIONNAIRE_ROUTES: Routes = [
  {
    path: '',
    component: QuestionnaireComponent,
    canActivate: [KeycloakAuthGuard, InstitutionIdFromQueryParamsGuard],
    children: [
      {
        path: 'overview',
        component: OverviewComponent,
      },
      {
        path: 'bank-wahl',
        component: DepotbankWahlComponent,
      },
      {
        path: 'dokumente',
        component: DokumenteComponent,
      },
      {
        path: 'zusammenfassung',
        component: ZusammenfassungComponent,
      },
      {
        path: 'blanko-dokumente',
        component: BlankoDokumenteComponent,
      },
      {
        path: 'einsicht',
        component: EinsichtComponent,
      },
      {
        path: 'identifizierung',
        component: IdentifizierungComponent,
      },
    ],
  },
];
